'use client';
import styled, { css } from 'styled-components';
import { Section, SectionTitle } from './styles';

export const StyledSummaryItem = styled(Section)`
  align-items: center;

  @media ${({ theme }) => theme.tablet} {
    align-items: none;
  }

  > div:first-of-type {
    margin-bottom: ${({ theme }) => theme.spacing(3)};

    @media ${({ theme }) => theme.tablet} {
      margin-right: ${props => props.theme.spacing(6)};
    }
  }
`;

export const OrderInfoGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
`;

export const OrderInfoList = styled.div`
  flex-grow: 1;
`;

export const OrderPricing = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(1)};
  position: absolute;
  right: 0;
  top: ${props => props.theme.spacing(1)};
`;

export const AddonsTitle = styled.div`
  ${props => props.theme.typography.heading5}
  font-weight: bold;
  margin: ${props => props.theme.spacing(5, 0, 1)};
`;

export const Price = styled.div`
  ${props => props.theme.typography.heading6}
  ${({ strikethrough }) =>
    strikethrough
      ? css`
          text-decoration: line-through;
          color: ${({ theme }) => theme.colors.text.tertiary};
          opacity: 0.75;
          margin-right: 0;

          @media ${({ theme }) => theme.tablet} {
            margin-right: ${({ theme }) => theme.spacing(3)};
          }
        `
      : css`
          font-weight: bold;
          color: ${({ theme }) => theme.colors.text.secondary};
        `}
  @media ${({ theme }) => theme.tablet} {
    ${({ theme, small }) =>
      small ? theme.typography.heading6 : theme.typography.heading4}
  }
`;

export const ListItemsContainer = styled.ul`
  list-style-type: none;
  padding: 0;
`;

export const StyledLiContainer = styled.li`
  position: relative;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;

export const SummaryItemTitle = styled(SectionTitle)`
  position: relative;
  max-width: 14rem;
  @media ${({ theme }) => theme.tablet} {
    max-width: 32rem;
  }
`;
export const ItemSize = styled.div`
  max-width: 14rem;
`;
export const StyledTitleAndPrice = styled.div`
  position: relative;
`;

export const StrikePrice = styled.span`
  text-decoration: line-through;
  color: ${props => props.theme.colors.status.errorPrimary};
  @media ${({ theme }) => theme.tablet} {
    ${({ theme, small }) =>
      small ? theme.typography.heading6 : theme.typography.heading4}
  }
  font-weight: normal;
`;

export const QuantityLabel = styled.span`
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.tertiary)};
`;
